module.exports = __webpack_public_path__ + "static/media/hydration_icon.37aedf70.svg";